import React, { Component } from 'react';
import Profile from '../../../../../../../../components/Profile';

/**
 * User screen, for showing a single users edit form.
 *
 * @extends React.Component
 */
class User extends Component {
  render() {
    return (
      <Profile userId={this.props.match.params.userId} />
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Users/screens/User/index.js